import React from 'react';
import s from './style.module.css';

import LazyableImage from '@Components/lazyable_image/view';
import lineIcon from '@Images/line-icon.webp';

const LineInquiry = () => {
    return (
        <a className={s.line_inquiry} href='https://lin.ee/N0T5zYW'>
            <LazyableImage src={lineIcon} width={28} height={28} alt='LINEでのお問合せ' />
            <span className={s.bolder}>LINE</span>
            <span>でのお問合せ</span>
        </a>
    );
};

export default LineInquiry;
